import GrantManagement from './grant-management';

// TODO: Change 'list' to 'show' later
export default {
  list: GrantManagement,
};
